<div class="w-full  hidden sm:flex sm:flex-col md:m-[0] sm:mt-[2rem]">
  <div class="w-full flex justify-center">
    <div class="w-[60%] sm:w-[90%] justify-between flex tab-section">
      <div (click)="setSelectedTab(0)"
           [class.selected-tab]="selectedTab === 0"
           class="w-[33.3%] flex justify-center tab items-center">
        Questionnaire
      </div>
      <div (click)="setSelectedTab(1)"
           [class.selected-tab]="selectedTab === 1"
           class="w-[33.3%] flex justify-center tab items-center">
        Settings
      </div>
      <div (click)="setSelectedTab(2)"
           [class.selected-tab]="selectedTab === 2"
           class="w-[33.3%] flex justify-center tab items-center">
        Summary
      </div>
    </div>
  </div>

  <div class="w-full detail-section">
    <app-edit-questionnaire
      *ngIf="selectedTab === 0"
      [clientId]="clientId"
      [groupId]="groupId"
      [loggedInUserRole]="loggedInUserRole"
      [surveyId]="surveyId"
      class="w-full"
    >
    </app-edit-questionnaire>
    <app-edit-settings
      *ngIf="selectedTab === 1"
      [clientId]="clientId"
      [groupId]="groupId"
      [loggedInUserRole]="loggedInUserRole"
      class="w-full"
    >
    </app-edit-settings>
    <app-edit-summary
      *ngIf="selectedTab === 2"
      [clientId]="clientId"
      [groupId]="groupId"
      [loggedInUserRole]="loggedInUserRole"
      [surveyId]="surveyId"
      class="w-full"
    >
    </app-edit-summary>
  </div>
</div>

<div class="flex sm:hidden">
  <app-screen-size-alert [hyperLinkText]="'Go Back To Manage Questionnaires'"
                         navigationLink="/stanford-admin/questionnaires/manage-questionnaires"></app-screen-size-alert>
</div>
